import { AxiosResponse } from "axios";
import { ICarrossel } from "../Interfaces/model/iCarrossel";
import { api } from "./api";

const url = "carrosel/";

const getAll = (): Promise<AxiosResponse<ICarrossel[]>> => {
  return api.get(url);
};

/**
 * Carrossel da home derivado automaticamente das noticias (tabela
 * carrosel_sisep). Cada item carrega o slug da noticia de origem.
 */
const getHomeCarrossel = (): Promise<AxiosResponse<ICarrossel[]>> => {
  return api.get("carrosel-sisep");
};

const create = (carrossel: ICarrossel): Promise<AxiosResponse<ICarrossel>> => {
  return api.post(url, carrossel);
};

const update = (
  id: number,
  carrossel: ICarrossel
): Promise<AxiosResponse<ICarrossel>> => {
  return api.put(`${url}${id}`, carrossel);
};

const remove = (id: number): Promise<AxiosResponse<void>> => {
  return api.delete(`${url}${id}`);
};

const carrosselService = {
  getAll,
  getHomeCarrossel,
  create,
  update,
  remove,
};

export default carrosselService;
